<a *ngIf="id && name" [routerLink]="['/ccpc/competitions/', id]">{{ name }}</a>
